import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { BootstrapIcon } from '../BootstrapIcon';

export function Directions() {
    return(
        <Row>
            <Col xs={12} className="pb-3">
                <h1>Directions to 57 Porter Street, Providence, RI</h1>
                <small><b>Note:</b> many GPS systems and mapping programs incorrectly identify 57 Porter Street as 26 Porter Street.</small>
            </Col>

            <Col xs={12} lg={6}>
                <a href="geo:41.79472585439055,-71.40299486031638;u=35"><Button><BootstrapIcon icon="geo-alt" /> Navigate</Button></a>

                <h2>Travel by Car</h2>
                <b>I-95 North</b> toward Providence
                <ul>
                    <li>Exit at <b>Thurbers Ave</b>. (exit 18) – stay to the <b>left</b></li>
                    <li>Drive straight through the light onto Thurbers Ave.</li>
                    <li><b>Left</b> at <b>Eddy St.</b> (across from the Shell station)</li>
                    <li><b>Left</b> onto <b>Earnest</b> (1st traffic light)</li>
                    <li>Right onto <b>Porter</b> (very sharp turn)</li>
                </ul>

                <b>I-95 South</b> toward Providence
                <ul>
                    <li>Exit at <b>Thurbers Ave</b>. (exit 18) – stay to the <b>right</b></li>
                    <li><b>Left</b> at <b>Eddy St.</b> (across from the Shell station)</li>
                    <li><b>Left</b> onto <b>Earnest</b> (1st traffic light)</li>
                    <li>Right onto <b>Porter</b> (very sharp turn)</li>
                </ul>


                <b>I-195, Rt. 146 and Rt. 6/10</b>
                <ul>
                    <li>Follow signs to downtown Providence</li>
                    <li>Connect to <b>I-95 South</b></li>
                    <li>Follow the directions above for I-95 South</li>
                </ul>
                
                <p>
                    Turn around at the top of the street. Parking is
                    restricted to one side of the street opposite the club.
                </p>
                Enter through the <b className="text-danger">Red Door</b>.
            </Col>
            <Col xs={12} lg={6}>
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.5658228320376!2d-71.40516208518835!3d41.79456987861737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e44ff47cea6bff%3A0x544c96172ad9289c!2s57%20Porter%20St%2C%20Providence%2C%20RI%2002905!5e0!3m2!1sen!2sus!4v1651892420743!5m2!1sen!2sus" 
                    width="100%" 
                    height="100%"
                    style={{ border:0, minHeight: "400px" }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Google Map"
                >

                </iframe>
            </Col>

            <Col xs={12} lg={6}>
                <h2>Local Taxi Services</h2>
                <p>
                    Reminder: when calling for a taxi, please only
                    provide the street address, not the name of the
                    business. Taxi services tend to be very busy at the
                    end of the night. We recommend calling ahead
                    early to arrange for pickup.
                </p>

                <ul>
                    <li>Big Daddy Taxi <a href="tel:4012741101">401-274-1101</a></li>
                    <li>Dominican Cab <a href="tel:4014213787">401-421-3787</a></li>
                    <li>Yellow Cab, Inc. <a href="tel:4019411122">401-941-1122</a></li>
                </ul>
            </Col>

            <Col xs={12} lg={6}>
                <h2>Travel by Bus</h2>
                <p>
                    Take the #1 Eddy St. bus to Johnson St. Porter is
                    one block north. Turn right onto Porter and look for
                    the red door on the left.
                </p>
                <p>
                    Take the #11 Broad St. bus to Hawthorne St. Porter
                    is one block south. Turn left onto Porter, walk two
                    and a half blocks, crossing Eddy St. Look for the
                    red door on the left.
                </p>
                <p>
                    Please note that busses stop running around
                    10:30pm. Please plan ahead by contacting a local
                    taxi service or making other arrangements.
                </p>
            </Col>
        </Row>
    )
}